// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/GestaoClientes_CarregaInfosGraficoDiarioResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for /gestao_clientes/carrega_infos_grafico_diario
 *
 * Returns array of daily statistics for the dashboard chart.
 */
import type { GestaoClientes_CarregaInfosGraficoDiarioRow } from './GestaoClientes_CarregaInfosGraficoDiarioRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type GestaoClientes_CarregaInfosGraficoDiarioResponseDados = GestaoClientes_CarregaInfosGraficoDiarioRow[];

export type GestaoClientes_CarregaInfosGraficoDiarioResponse = ApiResponse<GestaoClientes_CarregaInfosGraficoDiarioResponseDados>;

registerResponseContract('GestaoClientes_CarregaInfosGraficoDiarioResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      label:        { type: 'string',  required: true },
      orcamentos:   { type: 'number',  required: false },
      clientes:     { type: 'number',  required: false },
      compromissos: { type: 'number',  required: false },
      contatos:     { type: 'number',  required: false },
    },
  },
})
